"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var IconExpandMore_1 = require("./IconExpandMore");
var IconExpandLess_1 = require("./IconExpandLess");
var IconFile_1 = require("./IconFile");
var IconList_1 = require("./IconList");
var IconMenu_1 = require("./IconMenu");
var IconPlus_1 = require("./IconPlus");
var IconSearch_1 = require("./IconSearch");
var styles_1 = require("styles");
var icons = {
    expandMore: IconExpandMore_1.IconExpandMore,
    expandLess: IconExpandLess_1.IconExpandLess,
    file: IconFile_1.IconFile,
    list: IconList_1.IconList,
    menu: IconMenu_1.IconMenu,
    plus: IconPlus_1.IconPlus,
    search: IconSearch_1.IconSearch,
};
var componentStyle = {
    base: {
        width: 20,
        height: 20,
    },
};
var Icon = (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        var _a = this.props, style = _a.style, name = _a.name, color = _a.color, otherProps = __rest(_a, ["style", "name", "color"]);
        return React.createElement(icons[name], __assign({ style: Object.assign({}, componentStyle.base, style), color: color }, otherProps));
    };
    Icon.defaultProps = {
        color: styles_1.FontColor.Gray,
    };
    return Icon;
}(react_1.PureComponent));
exports.Icon = Icon;



//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Icon.tsx
// module id = 305
// module chunks = 0